/* eslint-disable */
export const EmailHelper = {
    isValid(email) {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test((email || '').trim());
    },
    getEmailValidator() {
        return {
            isValid: false,
            email: '',
            check(value) {
                const trimmed = (value || '').trim();
                this.email = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(trimmed) ? '' : "Please enter a valid email address";
                this.isValid = !this.email;
            }
        }
    }
}